'use client';
import { cx } from '@linaria/core';
import type { CSSProperties, ReactNode } from 'react';

import { type DropdownHookProps, useDropdown } from './hooks';
import { dropdown, DropdownMenu } from './styles';

export interface DropdownProps extends DropdownHookProps {
	className?: string;
	style?: CSSProperties;
	children?: ReactNode;
}

export const Dropdown = ({
	className,
	style,
	children,
	...props
}: DropdownProps) => {
	const popoverRef = useDropdown(props);

	return (
		<div
			ref={popoverRef}
			className={cx(dropdown, className)}
			style={style}
			popover="manual"
		>
			<DropdownMenu role="menu">{children}</DropdownMenu>
		</div>
	);
};
